import { render, staticRenderFns } from "./AddOrUpdateGoods.vue?vue&type=template&id=bb9bb9f0&scoped=true"
import script from "./AddOrUpdateGoods.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateGoods.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateGoods.vue?vue&type=style&index=0&id=bb9bb9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9bb9f0",
  null
  
)

export default component.exports